// NGXS 3 otherwise builds nested selectors with new Function, blocked by the invite CSP.
export const storeOptions = {
  compatibility: { strictContentSecurityPolicy: true },
};
